import { HttpMethod, Type } from "@/Utils/request/types";
import {
  AppointmentCreatePublicRequest,
  PublicAppointment,
  SchedulableResourceType,
  TokenSlot,
} from "@/types/scheduling/schedule";

export interface SpecialtyInfo {
  key: string;
  name_lt: string;
  name_en: string;
}

export interface Specialist {
  id: string;
  first_name: string;
  last_name: string;
  prefix: string | null;
  suffix: string | null;
  gender: string | null;
  username: string;
  profile_picture_url: string | null;
  consultation_fee_cents: number | null;
  specialties: SpecialtyInfo[];
  skills: SpecialtyInfo[];
}

export interface PublicSpecialty {
  key: string;
  name_lt: string;
  name_en: string;
  icon: string;
}

export interface SpecialtyFacility {
  id: string;
  name: string;
  read_cover_image_url: string | null;
}

export default {
  // Viešas specialybių katalogas — pacientų specialybės picker'iui.
  getPublicSpecialties: {
    path: "/api/v1/specialties/",
    method: HttpMethod.GET,
    TRes: Type<{ results: PublicSpecialty[] }>(),
  },
  // Viešos įstaigos, turinčios pasirinktos specialybės specialistų.
  getFacilitiesBySpecialty: {
    path: "/api/v1/facilities/",
    method: HttpMethod.GET,
    TRes: Type<{ specialty: string; results: SpecialtyFacility[] }>(),
  },
  // Vieši specialistai su kaina (consultation_fee_cents) + specialybė — booking
  // kortelėms rodyti kainą PRIEŠ prisijungimą.
  getSpecialists: {
    path: "/api/v1/specialists/",
    method: HttpMethod.GET,
    TRes: Type<{ facility: string; results: Specialist[] }>(),
  },
  getSlotsForDay: {
    path: "/api/v1/otp/slots/get_slots_for_day/",
    method: HttpMethod.POST,
    TRes: Type<{ results: TokenSlot[] }>(),
    TBody: Type<{
      facility: string;
      resource_type: SchedulableResourceType;
      resource_id: string;
      day: string;
    }>(),
  },
  // VIEŠI laisvi laikai (be paciento token'o) — kad laikus matytų PRIEŠ
  // prisijungimą.
  getPublicSlotsForDay: {
    path: "/api/v1/slots/",
    method: HttpMethod.POST,
    TRes: Type<{ results: TokenSlot[] }>(),
    TBody: Type<{
      facility: string;
      resource_type: SchedulableResourceType;
      resource_id: string;
      day: string;
    }>(),
  },
  getAppointments: {
    path: "/api/v1/otp/slots/get_appointments/",
    method: HttpMethod.GET,
    TRes: Type<{ results: PublicAppointment[] }>(),
  },
  getHealthSummary: {
    path: "/api/v1/otp/health/",
    method: HttpMethod.GET,
    TRes: Type<{
      results: {
        code: string;
        display: string;
        value: number | string | null;
        unit: string | null;
        datetime: string | null;
      }[];
    }>(),
  },
  createAppointment: {
    path: "/api/v1/otp/slots/{id}/create_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<AppointmentCreatePublicRequest>(),
  },
  cancelAppointment: {
    path: "/api/v1/otp/slots/cancel_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<{ appointment: string; patient: string }>(),
  },
  // Apmokėjimas (Neopay) po rezervacijos — paciento token'as. redirect_url =
  // kur naršyklė grįžta po apmokėjimo (care_fe payment puslapis).
  payAppointment: {
    path: "/api/v1/otp/appointments/{id}/pay/",
    method: HttpMethod.POST,
    TRes: Type<{
      payment_url: string | null;
      payment_id: string | null;
      paid: boolean;
      fee: string;
    }>(),
    TBody: Type<{ redirect_url?: string }>(),
  },
  getPaymentStatus: {
    path: "/api/v1/otp/appointments/{id}/payment-status/",
    method: HttpMethod.GET,
    TRes: Type<{
      appointment_id: string;
      paid: boolean;
      status: "paid" | "pending" | "unbilled";
      payment_id: string | null;
      expires_at: string | null;
    }>(),
  },
} as const;
